const initializeAreas = document.getElementById('wo-main-aree');
let map;
const areas = [];

// Check if initializeAreas exists
if (initializeAreas) {
    const milanButton = document.getElementById('milanoButton');
    const romeButton = document.getElementById('romaButton');
    const turinButton = document.getElementById('torinoButton');
    const parisButton = document.getElementById('parisButton');

    milanButton.addEventListener('click', function () {
        setActiveCity('Milano');
    });

    romeButton.addEventListener('click', function () {
        setActiveCity('Roma');
    });

    turinButton.addEventListener('click', function () {
        setActiveCity('Torino');
    });

    parisButton.addEventListener('click', function () {
        setActiveCity('Paris');
    });

    // Parse the URL for the 'city' parameter
    const params = new URLSearchParams(window.location.search);
    const cityParam = params.get('city');

    if (cityParam) {
        setActiveCity(cityParam);
    } else {
        // Optionally, set a default city if no 'city' parameter is present
        setActiveCity('Milano'); // Default to Milan
    }

    // Translation file for areas
    document.addEventListener('DOMContentLoaded', function () {
        const path = window.location.pathname;
        const languageMatch = path.match(/^\/(en|fr|it)\//);
        const languageCode = languageMatch ? languageMatch[1] : 'it'; // default to Italian

        const translationsAll = {
            en: translationsEn,
            fr: translationsFr,
            it: translationsIt
        };

        const translations = translationsAll[languageCode] || translationsIt;

        function updateContent() {
            // Update text content based on language
            document.getElementById('title').textContent = translations.areas.title;
            document.getElementById('subtitle').textContent = translations.areas.subtitle;

            document.getElementById('milanoText').textContent = translations.areas.milanoText;
            document.getElementById('romaText').textContent = translations.areas.romaText;
            document.getElementById('torinoText').textContent = translations.areas.torinoText;
            document.getElementById('parigiText').textContent = translations.areas.parigiText;
        }

        updateContent();
    });

    // Initialize map after loading city data
    loadCityData().then(() => {
        initMap();

        if (cityParam) {
            setActiveCity(cityParam);
        } else {
            // Optionally, set a default city if no 'city' parameter is present
            setActiveCity('Milano'); // Default to Milan
        }
    });
}

// Function to load city data before initializing the map
function loadCityData() {
    return getCitiesCoverage().then((response) => {
        const res = response.map(area => {
            return {
                ...area,
                polygon: area.boundaries.map(boundary => ({
                    lat: parseFloat(boundary.latitudeY.toFixed(5)),
                    lng: parseFloat(boundary.longitudeX.toFixed(5))
                }))
            };
        });

        areas.push(...res);
    });
}

function changeCity(area) {
    if (!area) return;

    const center = {lat: area.defaultCenterLatitude, lng: area.defaultCenterLongitude};
    map.setCenter(center);
    map.setZoom(area.defaultZoom);
}

function setActiveCity(cityName) {
    const cityArea = areas.find(area => area.city.name === cityName);

    document.querySelectorAll('.city-card-active').forEach(button => button.classList.remove('city-card-active'));
    document.getElementById(`${cityName.toLowerCase()}Button`).classList.add('city-card-active');

    if (!cityArea || cityArea.isHiddenOnWebsite) return;

    // Change the map to the selected city
    changeCity(cityArea);
}

// Initialize the map once city data is loaded
function initMap() {
    const mapOptions = {
        zoom: 13,
        center: {lat: 45.4654, lng: 9.1859},  // Default center (Milan)
        mapTypeId: 'roadmap',
    };

    const mapContainer = document.getElementById('aree-map-container');
    if (!mapContainer) return;

    map = new google.maps.Map(mapContainer, mapOptions);  // Make `map` accessible outside this function

    // Draw polygons for each city area
    areas.forEach(area => {
        if (area.isHiddenOnWebsite) return;

        const polygon = new google.maps.Polygon({
            paths: area.polygon,
            strokeColor: '#0e447d',
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: '#0e447d',
            fillOpacity: 0.35,
        });

        // Set the polygon on the map
        polygon.setMap(map);
    });
}
